// Copyright (c) 2022 by Move Closer

import { ModalConfig, ModalRegistry } from '@movecloser/front-core'
import { AsyncComponent, VueConstructor } from 'vue'

import { drawersRegistry as authDrawer } from '../front/auth/config/modals'
import { drawersRegistry as productDrawer } from '../front/products/config/modals'
import { drawersRegistry as checkoutDrawer } from '../front/checkout/config/modals'
import { modalsRegistry as checkout } from '../front/checkout/config/modals'
import { modalsRegistry as products } from '../front/products/config/modals'
import { modalsRegistry as shared } from '../front/shared/config/modals'

/**
 * @author Javlon Khalimjonov <javlon.khalimjonov@movecloser.pl>
 */
export const allModalsRegistry: ModalRegistry<VueConstructor|AsyncComponent> = {
  ...checkout,
  ...products,
  ...shared
}

export const allDrawerRegistry: ModalRegistry<VueConstructor|AsyncComponent> = {
  ...authDrawer,
  ...checkoutDrawer,
  ...productDrawer
}

/**
 * @author Javlon Khalimjonov <javlon.khalimjonov@movecloser.pl>
 */
export const drawerDefaultConfig = {}

/**
 * @author Javlon Khalimjonov <javlon.khalimjonov@movecloser.pl>
 */
export const frontModalDefaultConfig: ModalConfig = {}

/**
 * @author Javlon Khalimjonov <javlon.khalimjonov@movecloser.pl>
 */
export const MODAL_TRANSITION_DURATION: number = 300
